import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../store/user/selectors";
import { deletePoster } from "../../../store/poster/thunks";

const RemovePoster = ({ poster_id }) => {
  const dispatch = useDispatch();
  const tenant_id = useSelector(selectSelectedTenantId);

  const handleRemovePoster = useCallback(() => {
    Modal.confirm({
      title: "Remove Poster",
      content: `Are you sure you want to remove selected poster?`,
      okText: "Yes, Poster",
      okType: "danger",
      onOk: () => {
        return new Promise(async (resolve, reject) => {
          try {
            const result = await dispatch(
              deletePoster({
                poster_id,
                tenant_id,
              }),
            );

            resolve(result);
          } catch (error) {
            console.error("🚀 ~ handleRemovePoster ~ error:", error);
            reject(error);
          }
        });
      },
      onCancel: () => {
        console.log("Poster removal cancelled");
      },
    });
  }, [tenant_id, poster_id]);

  return (
    <Button onClick={handleRemovePoster} icon={<DeleteOutlined />} danger />
  );
};

export default RemovePoster;
